import { Box } from '@nimbus-ds/components';
import {
  ConceptCode,
  CurrencyType,
  PaymentFeeDto,
  SubscriptionRecurringFrequency,
} from '@tiendanube/common';
import { ChargeDataRows } from './components';

export interface ChargeDisplayInterface {
  description: string;
  amountValue: number;
  amountBaseValue?: number;
  amountCurrency: CurrencyType;
  appliedDiscounts?: {
    description: string;
    amountValue: number;
    amountCurrency: CurrencyType;
    rate: number;
    type?: string;
  }[];
  taxes?: {
    taxCode: string;
    amountValue: number;
    amountCurrency: CurrencyType;
    taxRate: number;
  }[];
  recurringInterval?: number;
  recurringFrequency?: SubscriptionRecurringFrequency;
  explanation?: {
    message: string;
    link: string;
  };
  conceptCode?: ConceptCode;
  fromDate?: string;
  toDate?: string;
  isProportional?: boolean;
}

interface PaymentDataContentProps {
  charges: ChargeDisplayInterface[];
  extraFees?: PaymentFeeDto[];
  showPeriodDiscounts: boolean;
}

function PaymentDataContent({
  charges,
  showPeriodDiscounts,
}: Readonly<PaymentDataContentProps>): JSX.Element {
  return (
    <Box display="flex" flexDirection="column" gap="4">
      {charges &&
        charges.map((charge) => (
          <ChargeDataRows
            key={charge.description + charge.conceptCode}
            charge={charge}
            showPeriodDiscounts={showPeriodDiscounts}
          />
        ))}
    </Box>
  );
}

export default PaymentDataContent;
